import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation, Trans } from "react-i18next";
import SignUpButton from "../../SignUpButton";
const HowCanIGetZmts = () => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      imageHCIGZ: file(relativePath: { eq: "images/how-can-i-get-zmts.jpg" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      <div id="how-can-i-get-zmts">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 img-placeholder px-0 order-lg-1">
              <img
                src={data.imageHCIGZ.publicURL}
                alt="How can I get ZMTs?"
                className="img-fill"
              />
            </div>
            <div className="col-lg-5 content d-flex align-items-center order-lg-0">
              <div>
                <div
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-easing="ease-out-cubic"
                  data-sal-delay="100"
                >
                  <h2>
                    <Trans i18nKey="zmt.how.title" components={[<i>ZMTs</i>]} />
                  </h2>
                </div>
                <div
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-easing="ease-out-cubic"
                  data-sal-delay="200"
                >
                  <p>{t("zmt.how.description")}</p>
                </div>

                <div
                  className="my-5"
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-easing="ease-out-cubic"
                  data-sal-delay="300"
                >
                  {" "}
                  <SignUpButton className="button button-secondary button-buy">
                    {t("zmt.btnOnBoard")} &#8594;
                  </SignUpButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowCanIGetZmts;
